module.exports = __webpack_public_path__ + "static/media/dec2024-2.718a04dc.webp";